module.exports = __webpack_public_path__ + "static/media/red-cross2.c9ebff9e.svg";